"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { NumberFormatter, SkuTranslator } from "@sticker-giant/sg-frontend-common";
import { IconChevronDown } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { isFinishedGood, isKissCut } from "@/lib/cart-item-utils";
import { cn } from "@/lib/utils";
import { PackagingMode } from "@/utils/resolvePackagingMode";
import type { RollDriverSelection } from "@/utils/rollQuantityUtils";
import { CartItemPackagingQuantity } from "./CartItemPackagingQuantity";
import type { CartPackagingSelection } from "./cartPackagingUtils";
import { DetailRow } from "./DetailRow";
export interface Props {
  item: CartItemOutputDto;
  packagingSelection?: CartPackagingSelection;
  showPackagingQuantityError: boolean;
  onPackagingQuantityChange: (selection: RollDriverSelection) => void;
  isLoading: boolean;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}
export function CartItemDetails(t0) {
  const $ = _c(29);
  const {
    item,
    packagingSelection,
    showPackagingQuantityError,
    onPackagingQuantityChange,
    isLoading,
    isOpen,
    setIsOpen
  } = t0;
  if (isFinishedGood(item)) {
    return null;
  }
  let t1;
  if ($[0] !== item) {
    t1 = SkuTranslator.getProductCategory(item.sku.product) === "labels" || isKissCut(item);
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showRollFinishing = t1;
  const hasSize = !!item.width && !!item.height;
  let t2;
  if ($[2] !== hasSize || $[3] !== item.height || $[4] !== item.width) {
    t2 = hasSize ? `${NumberFormatter.formatDecimal(item.width)}" x ${NumberFormatter.formatDecimal(item.height)}"` : undefined;
    $[2] = hasSize;
    $[3] = item.height;
    $[4] = item.width;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const sizeValue = t2;
  let t3;
  if ($[6] !== isOpen || $[7] !== setIsOpen) {
    t3 = () => setIsOpen(!isOpen);
    $[6] = isOpen;
    $[7] = setIsOpen;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = isOpen ? "Hide Details" : "View Details";
  const t5 = isOpen && "rotate-180";
  let t6;
  if ($[9] !== t5) {
    t6 = cn("transition-transform", t5);
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <IconChevronDown className={t6} />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t7) {
    t8 = <div className="mt-4 text-center"><Button variant="ghost" size="sm" onClick={t3}>{t4}{t7}</Button></div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isLoading || $[18] !== isOpen || $[19] !== item || $[20] !== onPackagingQuantityChange || $[21] !== packagingSelection || $[22] !== showPackagingQuantityError || $[23] !== showRollFinishing || $[24] !== sizeValue) {
    t9 = isOpen && <div className="mb-2 mt-8 flex flex-col gap-3 px-5"><DetailRow label="Product Type" value={item.product} /><DetailRow label="Material" value={item.material} /><DetailRow label="Size" value={sizeValue} /><DetailRow label="Lamination" value={item.laminate} /><DetailRow label="Shape" value={item.shape} /><DetailRow label="Finish" value={item.finish} />{showRollFinishing && <DetailRow label="Roll Finishing" value={item.orientation} />}<DetailRow label="Special Instructions" value={item.itemNotes} className="text-sm" /><DetailRow label="Uploaded Image" value={item.fileUrl} className="break-all text-sm" />{packagingSelection && packagingSelection.mode === PackagingMode.Roll && <CartItemPackagingQuantity item={item} mode={packagingSelection.mode} options={packagingSelection.options} selectedOption={packagingSelection.selectedOption} isLoading={isLoading} showError={showPackagingQuantityError} onPackagingQuantityChange={onPackagingQuantityChange} />}</div>;
    $[17] = isLoading;
    $[18] = isOpen;
    $[19] = item;
    $[20] = onPackagingQuantityChange;
    $[21] = packagingSelection;
    $[22] = showPackagingQuantityError;
    $[23] = showRollFinishing;
    $[24] = sizeValue;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t8 || $[27] !== t9) {
    t10 = <div>{t8}{t9}</div>;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}